export default __webpack_public_path__ + "static/media/peru_flag.3a2df6b7.svg";